export const RINGCENTRAL_STATE_KEY = 'workd:oauth:ringcentral_state';
export const QBO_STATE_KEY = 'workd:oauth:qbo_state';
export const VONAGE_STATE_KEY = 'workd:oauth:vonage_state';
